<template>
  <p class="footer-text">
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: 'FooterText'
}
</script>

<style scoped>
.footer-text {
  font-size: 0.95rem;
  line-height: 1.9;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
  transition: color 0.3s ease;
}

.footer-text:hover {
  color: rgba(255, 255, 255, 0.95);
}
</style>

